export default function getCustomerFullName(customer) {
  if (customer === undefined || customer === null) return null
  return customer.firstName + ' ' + customer.lastName
}
